import React__default, { createContext } from 'react';
import { DescendantProvider, useDescendant } from './reach-descendants.js';

const noop = param => {}; // eslint-disable-line @typescript-eslint/no-unused-vars

const ChildIndexContext = /*#__PURE__*/createContext({
  descendants: [],
  registerDescendant: noop,
  unregisterDescendant: noop
});
const ChildIndexProvider = _ref => {
  let {
    items,
    setItems,
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(DescendantProvider, {
    context: ChildIndexContext,
    items: items,
    set: setItems
  }, children);
};
function useChildIndex(_ref2) {
  let {
    element,
    ...rest
  } = _ref2;
  return useDescendant({
    element,
    ...rest
  }, ChildIndexContext);
}

export { ChildIndexContext, ChildIndexProvider, useChildIndex };
